// Implements: F-UIX-019
/**
 * A calendar day of a report (`YYYY-MM-DD`), written in the platform locale (`types/locale.ts`).
 *
 * The day is a calendar date in the zone of the report, not an instant: it is formatted at
 * UTC midnight in UTC, so no browser zone can move it to the day before. It is written in
 * Spanish whatever the browser's locale ("13 oct. 2026", never "Oct 13, 2026"), because it
 * sits inside Spanish copy. A string that is not a real day is shown as it came, never guessed.
 */

import { PLATFORM_LOCALE } from "../../../types/locale";

const DAY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const DAY = new Intl.DateTimeFormat(PLATFORM_LOCALE, { dateStyle: "medium", timeZone: "UTC" });

export function dayLabel(day: string): string {
  const match = DAY_RE.exec(day);
  if (match === null) return day;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const date = Number(match[3]);
  const instant = new Date(Date.UTC(year, month - 1, date));
  // `Date.UTC` rolls 2026-02-30 over to March: a day that does not exist is not shown as another.
  if (
    instant.getUTCFullYear() !== year ||
    instant.getUTCMonth() !== month - 1 ||
    instant.getUTCDate() !== date
  ) {
    return day;
  }
  return DAY.format(instant);
}
